import ACTION_TYPES, { Interfaces } from './actionTypes';
import ASYNC_STATE from '../constants/asyncState';
import { createFetchAction } from '../redux/fetchData';
import * as Models from 'models';

interface State {
  article?: Models.Article;
  fetchStatus: ASYNC_STATE;
}

export const initialState: State = {
  fetchStatus: ASYNC_STATE.NOT_STARTED,
};

export const moduleName = 'articles';

export const getArticle = (state: State) => state.article;
export const isFetchComplete = (state: State) => {
  return state.fetchStatus === ASYNC_STATE.DONE || state.fetchStatus === ASYNC_STATE.ERROR;
};

export default function articlesReducer(state: State, action: Interfaces.ActionType): State {
  switch (action.type) {
    case ACTION_TYPES.ARTICLES_FETCH:
      return {
        ...state,
        fetchStatus: ASYNC_STATE.LOADING
      };
    case ACTION_TYPES.ARTICLES_FETCH_RESPONSE:
      return {
        ...state,
        article: action.data,
        fetchStatus: ASYNC_STATE.DONE
      };
    case ACTION_TYPES.ARTICLES_FETCH_ERROR:
      return {
        ...state,
        fetchStatus: ASYNC_STATE.ERROR
      };
    default:
      return state;
  }
}

export function fetchArticle(id: string) {
  const action = createFetchAction({
    url: `${id}.json`,
    initActionType: ACTION_TYPES.ARTICLES_FETCH,
    successActionType: ACTION_TYPES.ARTICLES_FETCH_RESPONSE,
    failedActionType: ACTION_TYPES.ARTICLES_FETCH_ERROR,
  });

  return action;
}
